module.exports = "/static/assets/204d1ed39be62b431cebb92ee04309ca.png";